import { RootState } from 'rootReducer';

export const reservationsSelector = (state: RootState) => state.managerModuleReducer.reservationsReducer;
export const booksSelector = (state: RootState) => state.managerModuleReducer.reservationsReducer.books;
export const cellSettingsSelector = (state: RootState) => state.managerModuleReducer.reservationsReducer.cellSetting;
